import { Component, OnInit, Output, Input, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { benefitVariants } from './../../../../model/benefitsVariants';
import { QuoteCalcService, UtilService, SERVICE_END_POINT, AnalyticsService } from 'src/app/shared';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/state/app.state';
import { Observable } from 'rxjs/internal/Observable';
import * as resDataCalculationActions from '../../../../store/actions/response-quote-calculation.actions';
import { RefNo } from '../../../../model/ngrx/reference-number.model';
import * as RefNoActions from '../../../../store/actions/reference-number.actions';
import { Router } from '@angular/router';
import * as UserDataConfig from '../../config/user-data.config';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { QuoteDataCaptureService, LoaderService } from '../../../../shared';
import { ButtonService } from 'src/app/shared/services/api-services/button-loader.service';
import { Subscription } from 'rxjs/Subscription';
import { CurrencyFunctionalityService } from 'src/app/shared';
import { AlertModal } from 'src/app/model/alert';
import { CardRefresh } from 'src/app/model/ngrx/card-refresh.model';
import * as CardRefreshActions from '../../../../store/actions/card-refresh.actions';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { debounceTime, take } from 'rxjs/operators';

@Component({
  selector: 'app-quote-calculation-result',
  templateUrl: './quote-calculation-result.html',
  styleUrls: ['./quote-calculation-result.scss']
})
export class QuoteCalculationResultComponent implements OnInit, OnChanges {

  @Output() emittedCardNumber = new EventEmitter();
  @Output() editFlagEmitter = new EventEmitter();
  @Input() changeCard;
  @Input() productChoiceData;
  cardForm: UntypedFormGroup;
  protected userInputDetail = UserDataConfig.ElementsConfig;
  public benefitVariants: any;
  public benefitVariant: benefitVariants;
  public cardFlag: boolean = false;
  public cardAttributes;
  public cardIndex: number = null;
  public delVariant: any[];
  public flag: boolean;
  public indextobeDeleted: number;
  public cardLetter: string;
  public processedCard = [];
  public cardheader: string;
  public contentData;
  protected productCms;
  quoteCalculationStore: Observable<any[]>;
  yourOptions: any;
  screenName;
  referenceNumberStore: Observable<RefNo[]>;
  cardRefreshStore: Observable<CardRefresh[]>;

  referenceNumber: RefNo;
  editMode: boolean;
  selectedProduct: any;
  // Temp variables
  public totalConsideration: any;
  public commencementDate: any;
  public income: any;
  public taxFreeLumpSum: any;
  public annuitantPension: any;
  public incomeToDependant: any;
  public guaranteedTerm: any;
  public doneFlag: boolean = false;
  public refreshFlag: boolean = false;
  cardStoreVal: boolean;

  private CMSData;
  // Temp Variables for Income

  public paymentFrequency: string;
  public paymentAdvance: string;

  private subscription: Subscription;
  private subscriptionQuotecal: Subscription;
  isLocked: boolean = false;
  public lockedAlertModalConfig: AlertModal;
  constructor(private quoteCalcService: QuoteCalcService,
              private activatedRoute: ActivatedRoute,
              private store: Store<AppState>, private router: Router, private fb: UntypedFormBuilder,
              private quoteDataCaptureService: QuoteDataCaptureService, private loaderService: LoaderService,
              private buttonService: ButtonService, private utilService: UtilService,  private analyticsService: AnalyticsService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.youroptionscalculations;
    this.productCms = this.activatedRoute.snapshot.data.contentData.productChoice;
    this.quoteCalculationStore = store.select(STORE_VAL.quote_calculation);
    this.referenceNumberStore = this.store.select(STORE_VAL.ref_no);
    this.cardRefreshStore = store.select(STORE_VAL.card_Refresh);

    //console.log(this.quoteCalculationStore);
    // this.lockedAlertModalConfig = this.activatedRoute.snapshot.data.contentData['modalConfigLocked'];
    this.lockedAlertModalConfig = this.activatedRoute.snapshot.data.contentData['modalConfigLocked'];
    this.subscriptionQuotecal = this.quoteCalculationStore.subscribe(res => {
      console.log(res);
      if (res.length > 0) {
        this.yourOptions = res[0];
        this.benefitVariants = JSON.parse(JSON.stringify(res[0])).benefitVariants;
        this.setCardDetails();
        this.cardFlag = false;
      } else if (!this.quoteDataCaptureService.checkIfObjEmpty(res)){
        this.yourOptions = null;
        this.benefitVariants = null;
      }
    });

    this.referenceNumberStore.subscribe((val) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
        if (this.referenceNumber && this.referenceNumber.editMode) {
          this.editMode = true;
        } else {
          this.editMode = false;
        }
      }
    });
    this.cardRefreshStore.pipe(debounceTime(300)).subscribe((val) => {
      if (val) {
        this.cardStoreVal = val[0]?.['setCardRefresh'];
      }
    });
  }

  ngOnInit() {
    this.GetCMSDataServiceMapper();
    this.setCardForm();
    this.subscription = this.buttonService.loaderFlagState.subscribe(res => {
      this.doneFlag = res.flag;
    });
    if (this.productCms && this.productCms.products) {
      this.selectedProduct = this.productCms.products.filter((product, index) => {
        return (product.productName === this.productChoiceData?.productName);
      });
    }
    if (this.selectedProduct.length > 0) {
      this.selectedProduct = this.selectedProduct[0];
    }
    if (this.benefitVariants && this.benefitVariants.length > 0 && this.editMode) {
      let chosenCard = this.benefitVariants.filter(res => res.selected);
      const chosenCardIndex = this.benefitVariants.findIndex(res => res.selected);
      if (chosenCard && chosenCard.length > 0) {
        chosenCard = chosenCard[0];
        this.editCal(chosenCardIndex, chosenCard);
      }
    }
  }


  ngOnDestroy() {
    this.subscription.unsubscribe();
    if(this.subscriptionQuotecal){
      this.subscriptionQuotecal.unsubscribe();
    }
  }

  setCardForm = () => {
    this.cardForm = this.fb.group({
      choose: ['']
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes.changeCard && changes.changeCard.previousValue) {
    //   this.quoteCalculationStore = this.store.select('quoteCalculation');
    //   this.quoteCalculationStore.subscribe(res => {
    //     if (res.length > 0) {
    //       this.yourOptions = res[0];
    //       this.benefitVariants = JSON.parse(JSON.stringify(res[0])).benefitVariants;
    //       this.setCardDetails();
    //       this.cardFlag = false;
    //       // //console.log('this.benefitVariants => ', this.benefitVariants);
    //     }
    //   });
    // }
  }
  /*---delete
      common function for removing  element at particular index --*/

  deleteCal(i, card) {
    this.utilService.isQuoteLocked(this.referenceNumber ? this.referenceNumber?.quoteReferenceNumber : null).subscribe(
      resLock => {
        if (resLock) {
          this.isLocked = true;
        } else {
          this.isLocked = false;
          if (card.cardNumber === this.benefitVariants[i].cardNumber) {
            //console.log(this.benefitVariants);
            this.processedCard = this.removeCard(this.processedCard, i);
            // console.log(this.processedCard);
            // this.yourOptions.benefitVariants = this.processedCard;
            this.yourOptions = {...this.yourOptions , benefitVariants: this.processedCard};
            this.quoteDataCaptureService.deletecard(this.yourOptions).subscribe(res => {
              // this.router.navigate(['/quote/quote-variants']);
              this.cardFlag = false;
              this.emittedCardNumber.emit({ card: null, flag: this.cardFlag });
            });
            this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
            this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(this.yourOptions));
          }
        }
      }
    );
  }
  removeCard(array, index) {
    array.splice(index, 1);
    return array;
  }


  getReferenceAlphabet(i) {
    this.cardLetter = String.fromCharCode(i + 65);
    return this.cardLetter;
  }

  getIntegerAndFraction(card, productCode, type) {
    let integerString = null;
    let cardKey = null;
    let cardValue = null;
    let frequency = null;
    if (productCode === 'C') {
      if (card.quoteBasisModel.paymentFrequency === 'M') {
        frequency = this.contentData.currencyDurationMonthly;
        if (card.quickQuoteModel.annuitantPension) {
          integerString = String(card.quickQuoteModel.annuitantPension);
        } else {
          integerString = '0';
        }
      } else {
        frequency = this.contentData.currencyDurationYearly;
        if (card.quickQuoteModel.annuitantYearlyPension) {
          integerString = String(card.quickQuoteModel.annuitantYearlyPension);
        } else {
          integerString = '0';
        }
      }
    } else if (productCode === 'H') {
      if (card.benefitBasisModel[0].annualIncome && card.quickQuoteModel.annuitantPension
        && card.quickQuoteModel.annuitantYearlyPension) {
        // -----------Start----------------
        if (card.quoteBasisModel.paymentFrequency === 'M' || card.quoteBasisModel.paymentFrequency === 'Y'
          || card.quoteBasisModel.paymentFrequency === 'H' || card.quoteBasisModel.paymentFrequency === 'Q') {
          integerString = String(card.quickQuoteModel.annuitantMaturity);
          frequency = this.contentData.currencyDurationMaturity;
          cardKey = this.contentData.yearlyIncome;
          cardValue = '£' + card.quickQuoteModel.annuitantYearlyPension;
        }
        // ----------------------------------------------------------------------------

        // commented by msp7317
        // if (card.quoteBasisModel.paymentFrequency === 'M') {
        //   frequency = this.contentData.currencyDurationMonthly;
        //   if (card.quickQuoteModel.annuitantPension) {
        //     integerString = String(card.quickQuoteModel.annuitantPension);
        //   } else {
        //     integerString = 0;
        //   }
        // } else if (card.quoteBasisModel.paymentFrequency === 'Y') {
        //   frequency = this.contentData.currencyDurationYearly;
        //   if (card.quickQuoteModel.annuitantYearlyPension) {
        //     integerString = String(card.quickQuoteModel.annuitantYearlyPension);
        //   } else {
        //     integerString = 0;
        //   }
        // } else if (card.quoteBasisModel.paymentFrequency === 'H') {
        //   frequency = this.contentData.currencyDurationHalfYearly;
        //   if (card.quickQuoteModel.annuitantYearlyPension) {
        //     integerString = String(card.quickQuoteModel.annuitantYearlyPension / 2);
        //   } else {
        //     integerString = 0;
        //   }
        // } else if (card.quoteBasisModel.paymentFrequency === 'Q') {
        //   frequency = this.contentData.currencyDurationQuarterly;
        //   if (card.quickQuoteModel.annuitantYearlyPension) {
        //     integerString = String(card.quickQuoteModel.annuitantYearlyPension / 4);
        //   } else {
        //     integerString = 0;
        //   }
        // }
        // cardKey = this.contentData.yearlyIncome;
        // cardValue = '£' + card.quickQuoteModel.annuitantYearlyPension;
        // -------------------------End----------------------------------------------
        // end commented by msp7317

        // Commented Previously

        // else if (card.quoteBasisModel.paymentFrequency === 'Y') {
        //   integerString = String(card.quickQuoteModel.annuitantMaturity);
        //   frequency = this.contentData.currencyDurationMaturity;
        //   cardKey = this.contentData.yearlyIncome;
        //   cardValue = '£' + (card.quickQuoteModel.annuitantYearlyPension);
        // }
      }
      // Why is this Logic ??
      else if (card.benefitBasisModel[0].annualIncome !== null && card.benefitBasisModel[0].annualIncome.toString() === '0') {
        if (card.quickQuoteModel.annuitantPension === 0) {
          integerString = String(card.quickQuoteModel.annuitantMaturity);
          frequency = this.contentData.currencyDurationMaturity;
          cardKey = this.contentData.yearlyIncome;
          cardValue = 'None';
        }
      } else if (card.benefitBasisModel[0].maturityAmount && card.quickQuoteModel.annuitantMaturity) {
        if (card.benefitBasisModel[0].maturityAmount === card.quickQuoteModel.annuitantMaturity) {
          // --------Start------
          // if (card.quoteBasisModel.paymentFrequency === 'M') {
          //   integerString = String(card.quickQuoteModel.annuitantPension);
          //   frequency = this.contentData.currencyDurationMonthly;
          // } else {
          //   integerString = String(card.quickQuoteModel.annuitantYearlyPension);
          //   frequency = this.contentData.currencyDurationYearly;
          // }
          // ---------------------------------------------------------------
          if (card.quoteBasisModel.paymentFrequency === 'M') {
            frequency = this.contentData.currencyDurationMonthly;
            if (card.quickQuoteModel.annuitantPension) {
              integerString = String(card.quickQuoteModel.annuitantPension);
            } else {
              integerString = '0';
            }
          } else if (card.quoteBasisModel.paymentFrequency === 'Y') {
            frequency = this.contentData.currencyDurationYearly;
            if (card.quickQuoteModel.annuitantYearlyPension) {
              integerString = String(card.quickQuoteModel.annuitantYearlyPension);
            } else {
              integerString = '0';
            }
          } else if (card.quoteBasisModel.paymentFrequency === 'H') {
            frequency = this.contentData.currencyDurationHalfYearly;
            if (card.quickQuoteModel.annuitantYearlyPension) {
              integerString = String(card.quickQuoteModel.annuitantYearlyPension / 2);
            } else {
              integerString = '0';
            }
          } else if (card.quoteBasisModel.paymentFrequency === 'Q') {
            frequency = this.contentData.currencyDurationQuarterly;
            if (card.quickQuoteModel.annuitantYearlyPension) {
              integerString = String(card.quickQuoteModel.annuitantYearlyPension / 4);
            } else {
              integerString = '0';
            }
          }
          // -----------------------End----------------------------------------
          cardKey = this.contentData.maturityValue;
          cardValue = '£' + card.quickQuoteModel.annuitantMaturity;
        } else {
          integerString = String(card.quickQuoteModel.annuitantMaturity);
          frequency = this.contentData.currencyDurationMaturity;
          cardKey = this.contentData.yearlyIncome;
          cardValue = 'None';
        }
      }
    } else if (productCode === 'G') {
      if (card.quoteBasisModel.paymentFrequency === 'M') {
        frequency = this.contentData.currencyDurationMonthly;
        if (card.quickQuoteModel.annuitantPension) {
          integerString = String(card.quickQuoteModel.annuitantPension);
        } else {
          integerString = '0';
        }
      } else if (card.quoteBasisModel.paymentFrequency === 'Y') {
        frequency = this.contentData.currencyDurationYearly;
        if (card.quickQuoteModel.annuitantYearlyPension) {
          integerString = String(card.quickQuoteModel.annuitantYearlyPension);
        } else {
          integerString = '0';
        }
      } else if (card.quoteBasisModel.paymentFrequency === 'H') {
        frequency = this.contentData.currencyDurationHalfYearly;
        if (card.quickQuoteModel.annuitantYearlyPension) {
          integerString = String(card.quickQuoteModel.annuitantYearlyPension / 2);
        } else {
          integerString = '0';
        }
      } else if (card.quoteBasisModel.paymentFrequency === 'Q') {
        frequency = this.contentData.currencyDurationQuarterly;
        if (card.quickQuoteModel.annuitantYearlyPension) {
          integerString = String(card.quickQuoteModel.annuitantYearlyPension / 4);
        } else {
          integerString = '0';
        }
      }
    }
    // type 'I' for calculating integer part
    if (type === 'I') {
      integerString = integerString?.split('.')[0];
      integerString = CurrencyFunctionalityService.convertNumberToCurrency(integerString);
      // type 'D' for calculating decimal part
    } else if (type === 'D') {
      integerString = integerString?.split('.')[1] ?
        // tslint:disable-next-line:max-line-length
        (integerString.split('.')[1].length === 2 ? integerString.split('.')[1] :
          (integerString.split('.')[1].length === 1 ? integerString.split('.')[1] + '0' : '00')) : '00';
      // type 'F' for calculating frequency part
    } else if (type === 'F') {
      integerString = frequency;
      // type 'K' for calculating card key
    } else if (type === 'K') {
      integerString = cardKey;
      // type 'K' for calculating card value
    } else if (type === 'V') {
      if (cardValue !== 'None') {
        if (cardValue && cardValue.includes('.')) {
          cardValue = cardValue.split('.')[1].length === 2 ? cardValue : cardValue.concat('0');
        } else {
          cardValue = cardValue ? cardValue.concat('.00') : null;
        }
        integerString = CurrencyFunctionalityService.convertNumberToCurrency(cardValue);
      } else {
        integerString = cardValue;
      }
    }
    return integerString;
  }
  getInteger(annuitantPension) {
    let integerString = String(annuitantPension);
    return integerString.split('.')[0];
  }
  getFraction(annuitantPension) {
    let decimalString = String(annuitantPension);
    decimalString = (decimalString && decimalString.indexOf('.') > -1) ? decimalString.split('.')[1].substring(0, 2) : '';
    return decimalString.length > 1 ? '.' + decimalString :
      (decimalString.length === 1 ? '.' + decimalString + '0' : '.00');
  }

  getGuaranteedTermIndicator(benftBasis) {
    return benftBasis.guaranteedTermIndicator === 'N' ? 'None' : 'Whole term';
  }

  setCardDetails() {
    // this.processedCard = this.benefitVariants ? this.benefitVariants.quickQuote : [];
    this.processedCard = [];
    if (this.benefitVariants) {
      this.benefitVariants.forEach(val =>
        this.processedCard.push(val));
        console.log('this.processedCard' , this.processedCard);
      setTimeout(() => {
        if (this.cardFlag === false) {
          let htmlElement;
          if (this.cardIndex !== null) {
            htmlElement = document.getElementById('card' + (this.cardIndex));
          } else {
            htmlElement = document.getElementById('card' + (this.processedCard.length - 1));
          }
          if (htmlElement) {
            htmlElement.scrollIntoView();
          }
          this.cardIndex = null;
        }

      }); // scroll into view
    }
  }


  formatIncome(card) {
    let income;
    if (card.paymentFrequency === 'M') {
      this.paymentFrequency = 'Monthly';
    } else if (card.paymentFrequency === 'Y') {
      this.paymentFrequency = 'Yearly';
    } else if (card.paymentFrequency === 'Q') {
      this.paymentFrequency = 'Quarterly';
    } else if (card.paymentFrequency === 'H') {
      this.paymentFrequency = 'Half-yearly';
    }
    if (card.paymentAdvance === 'A') {
      this.paymentAdvance = 'In advance';
    } else if (card.paymentAdvance === 'B') {
      this.paymentAdvance = 'In arrears';
    }
    income = this.paymentFrequency + ' / ' + this.paymentAdvance;
    return income;
  }
  formatIncomeIncrease(card) {
    var incomeIncrease;
    switch (card.escalationType) {
      case 'N':
        incomeIncrease = 'No';
        break;
      case 'R':
        // incomeIncrease = 'Yes / RPI';
        incomeIncrease = 'RPI';
        break;
      case 'L':
        incomeIncrease = 'LPI';
        break;
      default:
        incomeIncrease = 'Fixed' + ' / ' + card.escalationRate + this.contentData.percentage;
        break;
    }
    return incomeIncrease;
  }

  editCal(i, card) {
    this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Edit quote', pageID: this.getCurrentScreenURL() });
    this.utilService.isQuoteLocked(this.referenceNumber ? this.referenceNumber?.quoteReferenceNumber : null).subscribe(
      res => {
        if (res) {
          this.isLocked = true;
        } else {
          this.isLocked = false;
          this.cardFlag = !this.cardFlag;
          this.cardIndex = i;
          //console.log(this.cardFlag, this.cardIndex, i);
          this.emittedCardNumber.emit({ card, flag: this.cardFlag });
        }
      }
    );
  }

  choose(i, card, disableChooseBtn) {
    this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Choose quote', pageID: this.getCurrentScreenURL() });
    if (disableChooseBtn === false) {
      this.benefitVariants.forEach(val => val.selected = false);
      if (card) {
        card.selected = true;
        if (this.benefitVariants && this.yourOptions && this.yourOptions.benefitVariants) {
          // this.yourOptions.benefitVariants = this.benefitVariants;
          this.yourOptions = {...this.yourOptions , benefitVariants: this.benefitVariants};
        }
        if(card.benefitBasisModel && card.benefitBasisModel.length > 0) {
          // this.yourOptions.benefitBasis = card.benefitBasisModel;
          this.yourOptions = {...this.yourOptions , benefitBasis: card.benefitBasisModel};
        }
        if(card.quoteBasisModel) {
          // this.yourOptions.quoteBasis = card.quoteBasisModel;
          this.yourOptions = {...this.yourOptions , quoteBasis: card.quoteBasisModel};
        }
       
      }
      if (this.editMode) {
        this.referenceNumber = {...this.referenceNumber, editMode: false};
        this.store.dispatch(new RefNoActions.RemoveReferenceNumber(0));
        this.store.dispatch(new RefNoActions.AddReferenceNumber(this.referenceNumber));
        this.editMode = false;
      }
      this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
      this.store.dispatch(new resDataCalculationActions.AddQuoteCalculation(this.yourOptions));
      this.router.navigate(['/quote/please-confirm-your-details']);
    }
  }

  done(i, card) {
    this.utilService.isQuoteLocked(this.referenceNumber ? this.referenceNumber?.quoteReferenceNumber : null).subscribe(
      res => {
        if (res) {
          this.isLocked = true;
        } else {
          this.isLocked = false;
          this.editFlagEmitter.emit({ card, flag: !this.cardFlag });
          // this.cardFlag = !this.cardFlag;
        }
      }
    );
  }
  refreshCard(i) {
    this.refreshFlag = true;
    //this.cardFlag = !this.cardFlag;
    this.cardIndex = i;
    this.quoteDataCaptureService.refreshCard(true, i).subscribe(res => {
      this.benefitVariants = res;
      this.setCardDetails();
      this.refreshFlag = false;
      this.store.dispatch(new CardRefreshActions.RemoveCardRefreshval(0));
      this.store.dispatch(new CardRefreshActions.AddCardRefreshval({ setCardRefresh: true }));
      // this.cardFlag = !this.cardFlag;
    },
      err => {
        this.refreshFlag = false;
        //this.cardFlag = !this.cardFlag;
      })
  }
  closeLockedModal() {
    this.isLocked = false;
  }
      /** Code block for CMS */
      GetCMSDataServiceMapper() {
        //console.log('changed value = ', this.contentData.infoIconData);

        const URL = SERVICE_END_POINT.higherEnvironment.CMS_YourProductOptions;
        this.utilService.getCMSData(URL).subscribe(res => {
          //console.log('2 GetCMSDataService => ', res);
          this.CMSData = res;
          if (this.CMSData) {
          /** In the line below we are over-writing the contentData object values with CMSData object values */
          this.contentData.quoteCardInfo = this.CMSData.string_MoreQuotesCardWording;
          this.contentData.cardRefreshText = this.CMSData.string_RefreshQuoteMessage;
          this.contentData.infoIconData.contentData = this.CMSData.string_RefreshQuoteMessageInfoPoint;
          this.contentData.cardText = this.CMSData.string_OptionChosen;
          this.contentData.editCalcButn = this.CMSData.string_EditQuoteCTALabel;
          this.contentData.chooseBtn = this.CMSData.string_ChooseQuoteCTALabel;
          this.contentData.doneEditingBtn = this.CMSData.string_DoneEditingCTALabel;
           //console.log('changed value = ', this.contentData.infoIconData);
        }
        });
      }
      /** End of code block for CMS */
       /** For web tracking */
       getCurrentScreenURL() {
        this.screenName = this.utilService.getScreenNameFromURL(this.router.url);

        return this.screenName;
        }
 
}
